module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921011149_T.f2572218.jpg";